const quantities = [];

for(let i = 1; i <= 20;i++){
  quantities.push({
    value: i, label: `${i} cafés`
  });
}

export default quantities;
